import React from "react";
import { Spin } from "antd";

const SpinIndicatior = ({ size = 24, color = "var(--sp-spin-color, #EB6B4C)", containerStyle }) => (
  <div style={{ display: "flex", alignItems: "center", justifyContent: "center", ...containerStyle }}>
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color }}
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <style>
        {`
        .spinner_z9k8{transform-origin:center;animation:spinner_StKS .75s infinite linear}
        @keyframes spinner_StKS{100%{transform:rotate(360deg)}}
      `}
      </style>

      <path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity=".25" />
      <path
        d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z"
        className="spinner_z9k8"
      />
    </svg>
  </div>
);

const Spinner = ({ children, color = "var(--sp-spin-color, #EB6B4C)", size, spinning, fullScreen, ...props }) => {
  const antDSizes = ["small", "default", "large"];
  const customSize = [20, 24, 32];
  const fillStyle = { width: "100%", height: "100%", minHeight: "100%" };
  const fullscreenStyle = { width: "100%", height: "100vh" };
  const containerStyle = fullScreen ? fullscreenStyle : fillStyle;

  if (children) {
    return (
      <Spin
        className="salespark-spinner"
        indicator={<SpinIndicatior size={customSize[antDSizes.indexOf(size)]} color={color} containerStyle={containerStyle} />}
        spinning={spinning}
        {...props}
      >
        <div style={containerStyle}>{children}</div>
      </Spin>
    );
  }

  return (
    <Spin
      className="salespark-spinner"
      indicator={<SpinIndicatior size={customSize[antDSizes.indexOf(size)]} color={color} containerStyle={containerStyle} />}
      spinning={spinning}
      {...props}
    />
  );
};

export default Spinner;
